<template>
  <div class="mtn-coverage-wrapper">
    <div class="card card-default p-3">
      <h4>MTN 5G/LTE Feasibility Check</h4>
      
      <div class="row mt-3">
        <div class="col-md-12">
          <iframe 
            ref="mapIframe"
            :src="`/html/mtn-map.html?key=${googleApiKey}`" 
            style="width: 400px; height: 400px; border: none;"
          ></iframe>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <button class="btn btn-primary" @click="checkMtnAvailability" :disabled="loading">
            <i v-if="loading" class="fa fa-spinner fa-spin"></i>
            <span v-else>Check Availability</span>
          </button>
        </div>
        <div class="col-md-8" v-if="feasibilityResult">
          <span class="badge" :class="['alert', feasibilityResult.isAvailable ? 'alert-success' : 'alert-danger']">
            <i :class="['fa', feasibilityResult.isAvailable ? 'fa-check-circle' : 'fa-times-circle', 'mr-2']"></i>
            {{ feasibilityResult.message }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  export default {
    data() {
      return {
        loading: false,
        feasibilityResult: null,
        googleApiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY
      };
    },
    methods: {
      checkMtnAvailability() {
        const iframeDoc = this.$refs.mapIframe.contentWindow.document;

        const getVal = (id) => {
          const el = iframeDoc.getElementById(id) || iframeDoc.querySelector(`input[name="${id}"]`);
          return el ? el.value : "";
        };

        const latLongRaw = getVal('latlong-input');
        let lat = "";
        let lon = "";

        if (latLongRaw && latLongRaw.includes(',')) {
          const parts = latLongRaw.split(',');
          lat = parseFloat(parts[0].trim()).toFixed(7);
          lon = parseFloat(parts[1].trim()).toFixed(7);
        }

        const addressParts = [
          getVal('streetofusage'),
          getVal('suburbofusage'),
          getVal('cityofusage'),
          getVal('provinceofusage'),
          getVal('postalofusage')
        ].filter(part => part && part.trim() !== "");

        const fullAddress = addressParts.join(', ') || "Unknown Address";

        const payload = {
          strLongitude: lon,
          strLatitude: lat,
          strAddress: fullAddress,
          strBBox: getVal('bbox-input'),
          strWidth: getVal('width-input') || "400",
          strHeight: getVal('height-input') || "400",
          strICoOrdinate: getVal('i-input') || "200",
          strJCoOrdinate: getVal('j-input') || "200"
        };

        if (!lat || lat === "NaN") {
          alert("Please select a valid location on the map first.");
          return;
        }

        this.loading = true;
        this.$http.post(this.$config.aimsAPI + 'axxess/lte/mtn/availability', payload)
          .then(res => {
            const data = res.body;
            
            const isAvailable = data.intCode === 200 && 
              !data.strMessage.toLowerCase().includes("no mtn") &&
              !data.strMessage.toLowerCase().includes("not available");

            this.feasibilityResult = {
              isAvailable: isAvailable,
              message: data.strMessage
            };
          })
          .catch(err => {
            console.error("API Error:", err);
            this.feasibilityResult = { 
              isAvailable: false, 
              message: "The feasibility service is currently unavailable. Please try again later." 
            };
          })
          .finally(() => this.loading = false);
      }
    }
  };
</script>